// Bilingual mirror of /app/backend/property_taxonomy.py
// Keys MUST stay identical to the backend constants.

export const CONDITION_STATUS_OPTIONS = [
  { key: 'obra_gris',  en: 'Unfinished',                                          es: 'Obra Gris' },
  { key: 'rented',     en: 'Rented, with tenants',                                es: 'Alquilada, con inquilinos' },
  { key: 'available',  en: 'Available, no restrictions',                          es: 'Disponible, sin restricciones' },
];

export const CONDITION_STATE_OPTIONS = [
  { key: 'new_build',         en: 'New build',         es: 'Obra nueva' },
  { key: 'good',              en: 'Good condition',    es: 'Buen estado' },
  { key: 'needs_renovation',  en: 'Needs renovation',  es: 'A reformar' },
];

export const FLOOR_LEVEL_OPTIONS = [
  { key: 'penthouse',     en: 'Penthouse',     es: 'PH' },
  { key: 'mid_floors',    en: 'Mid floors',    es: 'Plantas intermedias' },
  { key: 'ground_floor',  en: 'Ground floor',  es: 'Planta Baja' },
];

export const FEATURE_OPTIONS = [
  { key: 'air_conditioning',    en: 'Air conditioning',     es: 'Aire acondicionado' },
  { key: 'built_in_wardrobes',  en: 'Built-in wardrobes',   es: 'Armarios empotrados' },
  { key: 'elevator',            en: 'Elevator',             es: 'Ascensor' },
  { key: 'balcony_terrace',     en: 'Balcony and terrace',  es: 'Balcón y terraza' },
  { key: 'exterior',            en: 'Exterior',             es: 'Exterior' },
  { key: 'garage',              en: 'Garage',               es: 'Garaje' },
  { key: 'garden',              en: 'Garden',               es: 'Jardín' },
  { key: 'swimming_pool',       en: 'Swimming pool',        es: 'Piscina' },
  { key: 'storage_room',        en: 'Storage room',         es: 'Trastero' },
  { key: 'luxury',              en: 'Luxury property',      es: 'Vivienda de lujo' },
  { key: 'sea_views',           en: 'Sea views',            es: 'Vistas al mar' },
  { key: 'mountain_views',      en: 'Mountain views',       es: 'Vistas a la montaña' },
];

export const BEDROOM_OPTIONS = [
  { key: '0',     en: '0 (Studio)',              es: '0 (Estudio)' },
  { key: '1',     en: '1',                       es: '1' },
  { key: '2',     en: '2',                       es: '2' },
  { key: '3',     en: '3',                       es: '3' },
  { key: '4plus', en: '4 or more bedrooms',      es: '4 habitaciones o más' },
];

export const BATHROOM_OPTIONS = [
  { key: '1',     en: '1',                       es: '1' },
  { key: '2',     en: '2',                       es: '2' },
  { key: '3plus', en: '3 or more bathrooms',     es: '3 baños o más' },
];

export const PUBLICATION_WINDOW_OPTIONS = [
  { key: 'any',   en: 'Any time',          es: 'Indiferente' },
  { key: '48h',   en: 'Last 48 hours',     es: 'Últimas 48 horas' },
  { key: '1w',    en: 'Last week',         es: 'La última semana' },
  { key: '1m',    en: 'Last month',        es: 'El último mes' },
];

// Helpers used across forms
export function bedroomKeyToValue(key) {
  // For property storage, integer; "4plus" stored as 4 (and any value >=4 matches the filter).
  return key === '4plus' ? 4 : parseInt(key, 10);
}
export function bedroomValueToKey(val) {
  if (val === null || val === undefined) return '';
  const n = parseInt(val, 10);
  if (Number.isNaN(n)) return '';
  if (n >= 4) return '4plus';
  return String(n);
}
export function bathroomKeyToValue(key) {
  return key === '3plus' ? 3 : parseInt(key, 10);
}
export function bathroomValueToKey(val) {
  if (val === null || val === undefined) return '';
  const n = parseInt(val, 10);
  if (Number.isNaN(n)) return '';
  if (n >= 3) return '3plus';
  return String(n);
}

export function labelFor(opts, key, lang) {
  const o = opts.find(x => x.key === key);
  if (!o) return key || '';
  return lang === 'es' ? o.es : o.en;
}
